<template>
  <div>
    <div>
      <button
        @click="isExpanded = !isExpanded"
        class="border-ontick-steel-300 dark:border-ontick-steel-500 w-full overflow-hidden border-2 shadow sm:rounded-lg px-3 py-3 xl:px-6 flex flex-col text-left"
        :class="{
          'bg-ontick-steel-100 dark:bg-ontick-steel-500 pb-0 divide-ontick-steel-400 dark:divide-ontick-graphite-500 divide-y gap-2':
            isExpanded,
        }"
      >
        <!-- SUMMARY -->
        <div class="flex justify-between w-full">
          <div class="flex flex-col items-start">
            <span class="text-ontick-blue-500 font-semibold uppercase">
              {{ overallDirection }}
            </span>
            <span
              class="text-ontick-carbon-900 text-xs dark:text-gray-400 xl:text-sm"
            >
              {{ data.position.position_symbol }} ·
              {{ data.position.position_volume }}
              {{ data.position.volume_type }}
            </span>
          </div>
          <div class="flex flex-col items-end">
            <span
              class="text-ontick-blue-500 text-right font-semibold"
              :class="
                data.position.all_profit > 0
                  ? 'text-ontick-green-700 dark:text-ontick-green-500'
                  : data.position.all_profit < 0
                  ? 'text-ontick-red-700 dark:text-ontick-red-500'
                  : 'text-ontick-carbon-900 dark:text-gray-300'
              "
            >
              {{ data.position.all_profit | currency }}
            </span>
            <span
              class="text-ontick-carbon-900 text-xs dark:text-gray-400 xl:text-sm"
            >
              {{ data.position.position_time_open | moment("from", "now") }}
            </span>
          </div>
        </div>

        <!-- LIST -->
        <ul class="text-xs w-full" v-if="isExpanded">
          <li
            v-for="(order, index) in data.orders"
            :key="index"
            class="py-2 grid grid-cols-7 w-full font-semibold"
          >
            <div class="col-span-2 col">
              <span>
                {{ moment(order.order_time_done).format("LLL") }}
              </span>
            </div>
            <div class="col uppercase">
              <span>
                {{ goalDict(order.order_goal) }}
              </span>
            </div>
            <div class="col">
              <span>
                {{ order.order_direction }}
              </span>
            </div>
            <div class="col">
              <span>
                {{ order.order_type }}
              </span>
            </div>
            <div class="col">
              <span>
                {{ order.order_price }}
              </span>
            </div>
            <div
              class="col"
              :class="[
                { 'text-ontick-green-600': order.order_profit > 0 },
                { 'text-ontick-red-600': order.order_profit < 0 },
              ]"
            >
              <span>
                {{ order.order_profit | currency }}
              </span>
            </div>
          </li>
        </ul>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object },
    index: {
      type: Number,
    },
  },

  data() {
    return {
      isExpanded: false,
    };
  },

  computed: {
    overallDirection() {
      return this.data.orders.find((item) => item.order_goal === "ENTRY")
        .order_direction;
    },
  },

  methods: {
    showInvestmentPortfolio(inv) {
      const index = this.toogle.indexOf(inv);
      if (index > -1) {
        this.toogle.splice(index, 1);
      } else {
        this.toogle.push(inv);
      }
    },
    goalDict(goal) {
      switch (goal) {
        case "ENTRY":
          return "Entrada";
        case "EXIT":
          return "Saída";
        default:
          return goal;
      }
    },
  },

  watch: {
    data: {
      immediate: true,
      handler(values) {
        let result = 0;
        values.orders.forEach((item) => {
          result = result + item.order_profit;
          values.position.all_profit = result;
        });
        return values;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.col {
  @apply first:text-left last:text-right text-center;
}
</style>
